// index.js
import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import { AuthProvider } from './context/AuthContext';
import App from './App';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement); // Create a root using createRoot

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />  {/* No need for BrowserRouter here; it's already in App */}
    </AuthProvider>
  </React.StrictMode>
);
